// see also https://www.npmjs.com/package/classnames
import { compact, flatten, map, uniq } from "lodash/fp";
const NS = "kaavio";
export const classNamesToArray = function (...inputs) {
    return uniq([
        ...map((input) => input
            .replace(/([^a-zA-Z0-9\-\_\u00A0-\uFFFF])/g, "_")
            .replace(/^(\d|\-\-|\-\d)/, "_"), compact(flatten(inputs)))
    ]);
};
export const classNamesToString = function (...inputs) {
    const classString = classNamesToArray(flatten(inputs));
    return classString.join(" ");
};
/*
export const formatClassNames = function(
  ...inputs: (string | string[])[]
): string {
  const classString = uniq([
    ...map(
      (input: string) =>
        input
          //.replace(/\ /g, "_")
          .replace(/([^a-zA-Z0-9\-\_\u00A0-\uFFFF])/g, "_")
          .replace(/^(\d|\-\-|\-\d)/, "_"),
      compact(flatten(inputs))
    )
  ]).join(" ");

  return classString;
};
//*/
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0Q2xhc3NOYW1lcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9mb3JtYXRDbGFzc05hbWVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLG9EQUFvRDtBQUVwRCxPQUFPLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxHQUFHLEVBQUUsSUFBSSxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBRXhELE1BQU0sRUFBRSxHQUFHLFFBQVEsQ0FBQztBQUVwQixNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxVQUMvQixHQUFHLE1BQTZCO0lBRWhDLE9BQU8sSUFBSSxDQUFDO1FBQ1YsR0FBSSxHQUFHLENBQ0wsQ0FBQyxLQUFhLEVBQUUsRUFBRSxDQUNoQixLQUFLO2FBQ0YsT0FBTyxDQUFDLGtDQUFrQyxFQUFFLEdBQUcsQ0FBQzthQUNoRCxPQUFPLENBQUMsaUJBQWlCLEVBQUUsR0FBRyxDQUFDLEVBQ3BDLE9BQU8sQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FDWjtLQUNmLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHLFVBQ2hDLEdBQUcsTUFBNkI7SUFFaEMsTUFBTSxXQUFXLEdBQUcsaUJBQWlCLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxDQUFDLENBQUM7SUFDdkQsT0FBTyxXQUFXLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0FBQy9CLENBQUMsQ0FBQztBQUVGOzs7Ozs7Ozs7Ozs7Ozs7OztJQWlCSSJ9